import { useForm } from 'react-hook-form';

import { CancellationReasonEnum } from '@mopla/data-models';

import { ICancelFormValues } from '../types';

export const useDTicketSubscriptionCancelForm = () => {
	const { control, handleSubmit, watch } = useForm<ICancelFormValues>({
		defaultValues: {
			reason: null,
			otherReasonText: '',
			acceptConditions: false,
		},
	});

	const selectedReason = watch('reason');
	const acceptConditions = watch('acceptConditions');
	const otherReasonText = watch('otherReasonText');

	const isOtherReasonSelected =
		selectedReason === CancellationReasonEnum.OTHER_REASON;
	const isOtherReasonValid =
		!isOtherReasonSelected || otherReasonText.trim().length > 0;
	const isFormValid =
		!!selectedReason && acceptConditions && isOtherReasonValid;

	const onSubmit = (
		onCancelSubscription: (
			reason: CancellationReasonEnum,
			otherReasonText?: string
		) => void
	) => {
		return handleSubmit(({ reason, otherReasonText }) => {
			if (!reason) return;
			const isOther = reason === CancellationReasonEnum.OTHER_REASON;
			onCancelSubscription(reason, isOther ? otherReasonText : undefined);
		});
	};

	return {
		control,
		selectedReason,
		isOtherReasonSelected,
		isFormValid,
		onSubmit,
	};
};
